import classNames from 'classnames';
import { FC } from 'react';

import styles from './Counter.module.scss';

interface CounterProps {
  className?: string;
  variant?: 'primary' | 'secondary';
}

/**
 * Renders an icon with an incrementing value for lists, arrays, etc.
 * Import 'counterWrapperStyle' and attach to a parent of the items to be counted.
 */
export const Counter: FC<CounterProps> = ({ className, variant = 'primary' }) => (
  <div className={classNames(styles.root, className)}>
    <div className={classNames(styles.circle, styles[variant])} />
  </div>
);

export const counterWrapperStyle = styles.parent;
